import {
    onCLS,
    onFCP,
    onINP,
    onLCP,
    onTTFB,
} from 'web-vitals';

import { sendStats } from '@api/user/stats';
import { EventCategory, EventType } from '@shared/types';

import type { Metric } from 'web-vitals';

export const captureMetrics = (version: string, isDesktopSite: boolean, page: string) => {
    const queue = new Set<{ name: string; value: number }>();
    function addToQueue(metric: Metric) {
        queue.add({ name: metric.name, value: metric.value });
    }

    onCLS(addToQueue, { reportAllChanges: false });
    onINP(addToQueue, { reportAllChanges: false });
    onLCP(addToQueue, { reportAllChanges: false });
    onFCP(addToQueue, { reportAllChanges: false });
    onTTFB(addToQueue, { reportAllChanges: false });

    addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'hidden') {
            flushQueue();
        }
    });

    function flushQueue() {
        if (queue.size > 0) {
            sendStats(EventType.FrontendMetricsCapture, EventCategory.FrontendMetrics, isDesktopSite, {
                frontend_metrics: {
                    version,
                    metrics: [...queue],
                    page,
                },
            });

            queue.clear();
        }
    }
};
